import { LicenseManager } from '../../managers/License.manager';
import { Component, OnDestroy } from '@angular/core';
import { WindowBase } from '../../services/window-dialogs/window.base';
import { WindowEvent, WindowActionTypes } from '../../services/window-dialogs/window.event';
import { Subscription } from 'rxjs';


@Component({
  selector: 'license-details-window',
  styleUrls: ['./license.details.window.css'],
  templateUrl: './license.details.window.html'
})
export class LicenseDetailsWindow extends WindowBase<string> implements OnDestroy {

  licenseManager: LicenseManager;
  private licenseManagerSubscription: Subscription;
  private memberNavigateSubscription : Subscription;


  constructor() {
    super();
  }


  ngOnDestroy() {
    this.licenseManagerSubscription.unsubscribe();
  }

  Init() {

    this.licenseManager = new LicenseManager(this.Context.Data, true);

    this.licenseManagerSubscription = this.licenseManager.OnChangesSaveResponse.subscribe( response => { 
      console.log("licenseManager Subscription response:", response);
      this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
      window.close();
    });

    this.memberNavigateSubscription = this.licenseManager.OnMemberNavigate.subscribe( response => { 
      console.log("MemberNavigate Subscription response:", response);
      this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.NavigateToMember, response));
    });

  }

  public ClickMe() {
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, "test"))

  }


}